import { useField } from "formik";
import Select from "components/form/Select";

import task_priority_data from "libs/task_priority_data.json";

const Priority = ({ name, ...rest }) => {
  const [field, , helpers] = useField(name);

  const selected = task_priority_data.find((item) => item.value === field.value);

  return (
    <Select.Priority
      {...rest}
      selected={selected}
      onChange={(option) => helpers.setValue(option.value)}
    />
  );
};

export default Priority;
